/**
 * @generated SignedSource<<1c95be55b16510ba604af75e2ef1db99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data = {
  readonly id: string;
  readonly isEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView">;
  readonly " $fragmentType": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell";
};
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key = {
  readonly " $data"?: linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditableInIssueView"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "4bb96af15bfeeb8439c2a314f25d54c7";

export default node;
